import { SwiperOptions } from 'swiper';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ShopAndProductService } from '../service/shop-and-product.service';

@Component({
  selector: 'app-view-and-update-product',
  templateUrl: './view-and-update-product.component.html',
  styleUrls: ['./view-and-update-product.component.css']
})
export class ViewAndUpdateProductComponent implements OnInit {

  config: SwiperOptions = {
    pagination: { 
      el: '.swiper-pagination', 
      clickable: true 
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    autoplay : true,
    fadeEffect : { crossFade : true},
    spaceBetween: 30
  };

  product : any;

  apiBaseUrl = environment.url;
  selectedColors;
  backgroundColor = '#FFFFFF80';


  constructor(private _activateRoute : ActivatedRoute, private _shopAndProductService : ShopAndProductService) {
    
   }

  ngOnInit(): void {
    console.log(this._activateRoute.snapshot.paramMap)
    this.getProductDetailById(this._activateRoute.snapshot.paramMap.get('id'))
  }

  getProductDetailById(productId : string){
     this._shopAndProductService.getProductById(productId).subscribe((resp : any) =>{
          if(resp.status == 200){
              this.product = resp.data;
              this.selectedColors = resp.data.color
              console.log(this.selectedColors,"oooooooooooooooooo")

          }
     })
  }

}
